import React from "react";
import CustomerContent from "../content/customerContent";
import Layout from "../layout/Layout";

const Customer = () => {
  return (
    <Layout>
      <CustomerContent />
    </Layout>
  );
};

export default Customer;
